import { FaPinterest, FaWhatsapp } from "react-icons/fa";

export const FiverrIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      fill="#ffffff"
      viewBox="-5 -5 24 24"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin"
      className={
        className == undefined || className == "" || className.length <= 0
          ? `w-7 h-7 jam jam-fiverr fill-gray-200 transition-colors duration-300 hover:fill-[#1DBF73]`
          : `${className} `
      }
    >
      <g id="SVGRepo_iconCarrier" transform="scale(0.75)">
        <path d="M16.25 16.25v-10h-10v-.625c0-1.034.841-1.875 1.875-1.875H10V0H8.125A5.632 5.632 0 0 0 2.5 5.625v.625H0V10h2.5v6.25H0V20h8.75v-3.75h-2.5V10h6.285v6.25H10V20h8.75v-3.75h-2.5z"></path>
        <circle cx="14.375" cy="1.875" r="1.875"></circle>
      </g>
    </svg>
  );
};

export const links = [
  {
    label: "Fiverr",
    icon: <FiverrIcon className="w-6 h-6" />,
    href: "https://www.fiverr.com/silvintage",
  },
  {
    label: "Pinterest",
    icon: <FaPinterest className="w-5 h-5" />,
    href: "https://id.pinterest.com/silvintageID",
  },
  {
    label: "Whatsapp",
    icon: <FaWhatsapp className="w-5 h-5" />,
    href: "https://api.whatsapp.com/send?phone=6283818181806&text=Hay%2C%20I%20wanna%20order%20this%20design%20!",
  },
  // {
  //   label: "Email",
  //   icon: <Mail className="w-5 h-5" />,
  //   href: "mailto:your.email@domain.com",
  // },
  // {
  //   label: "LinkedIn",
  //   icon: <Linkedin className="w-5 h-5" />,
  //   href: "https://id.linkedin.com/in/jehan-afwazi",
  // },
];
